import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { reducer as notifications } from "react-notification-system-redux";

import {
  tabsReducer,
  loginReducer,
  signupReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  mailConfirmationReducer,
  queryPageRequest,
  queryPageProgramRequest,
  queryPageByIdRequest,
  getRequest,
  getByIdRequest,
  postRequest,
  postByIdRequest,
  putRequest,
  putByIdRequest,
  deleteRequest,
  setRequest,
  reportSave,
  reportActivityList,
  reportActivityProfileImage,
  reportCommentCreate,
  reportCommentAttachment,
  newCount,
  listType,
  getResearcherByEmail,
  attachmentGetByIdRequest,
  downloadRequest,
  listQueryPageRequest
} from "./redux/reducers/index";


const reducer = combineReducers({

  // Notification
  notifications,

  //Tab
  tabs: tabsReducer,

  // Auth
  login: loginReducer,
  signup: signupReducer,
  forgetPass: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  mailConfirmation: mailConfirmationReducer,

  //master
  skillList: getRequest('skill/list'),
  interestList: getRequest('interest/list'),
  countryList: getRequest('country/list'),
  languageList: getRequest('language/list'),
  vulnerabilityCategoryList: getRequest('vulnerability/category/list'),
  programByResearcherList: getRequest('researcher/program/join/list'),
  reportByResearcherList: getRequest('program/report/researcher/submitted/list'),
  paymentByResearcherList: getRequest('payment/transaction/byresearcher/list'),
  organizationList: getRequest('organization/list'),
  workingAreaList: getRequest('working/area/list'),

  researcherProgramRecommendedDashboardList: getRequest('researcher/program/recommended/dashboard/list'),

  // Program
  programNewQueryPage: queryPageRequest('program/new'),
  programEndingQueryPage: queryPageRequest('program/ending'),
  researcherProgramRecommendedDashboardQueryPage: queryPageRequest('researcher/program/recommended'),
  researcherProgramFollowingDashboardQueryPage: queryPageRequest('researcher/program/following'),

  programListType: listType('program'),
  programAllQueryPage: queryPageProgramRequest('program/all'),
  researcherProgramFollowingQueryPage: queryPageProgramRequest('researcher/program/following'),
  researcherProgramRecommendedQueryPage: queryPageProgramRequest('researcher/program/recommended'),
  researcherProgramRecommendedList: listQueryPageRequest('researcher/program/recommended'),
  researcherProgramJoinedQueryPage: queryPageProgramRequest('researcher/program/joined'),
  researcherProgramFollow: putByIdRequest('researcher/program/follow/set'),
  researcherProgramUnfollow: putByIdRequest('researcher/program/follow/remove'),
  researcherProgramJoin: putByIdRequest('researcher/program/join/set'),
  researcherProgramUnjoin: putByIdRequest('researcher/program/join/remove'),
  programStat: getByIdRequest('program/stat'),
  programReportStat: getByIdRequest('program/report/stat'),
  programId: getByIdRequest('program/id'),
  programReportSave: postRequest('program/report/save'),
  programScope: getByIdRequest('program/scope/byprogram'),
  programReward: getByIdRequest('program/reward/byprogram'),
  programRequestType: getRequest('program/request/type/list'),
  programRequestSend: setRequest('program/request/send'),
  programReportHacktionByProgram: queryPageByIdRequest('program/report/hacktion/byprogram'),
  researcherByEmail: getResearcherByEmail(),
  researcherProgramJoinedDashboardQueryPage: queryPageRequest('researcher/program/joined'),
  researcherProgramJoinRecentlyListByprogram: getByIdRequest('researcher/program/join/recently/list/byprogram'),

  // Draft
  programReportDraftQueryPage: queryPageRequest('program/draft/report/all'),
  draftReportSave: postRequest('program/draft/report/save'),
  draftReportId: getByIdRequest('program/draft/report/id'),
  draftReportDelete: deleteRequest('program/draft/report'),
  draftReportCollaborateDelete: deleteRequest('program/draft/report/collaborate'),
  draftReporCollaborateByReport: getByIdRequest('program/draft/report/collaborate/bydraftreport'),
  draftReportAttachmentFile: postByIdRequest('program/draft/report/attachment/file/attach'),
  draftReportAttachmentFileList: attachmentGetByIdRequest('program/draft/report/attachment/file/list'),
  draftReportAttachmentFileDelete: deleteRequest('program/draft/report/attachment/file'),
  draftReportAttachmentFileDownload: downloadRequest('program/draft/report/attachment/file'),
  
  // Report
  reportSave: reportSave(),
  programScopeByReport: getByIdRequest('program/scope/byreport'),
  programReportResearcherSubmittedQueryPage: queryPageRequest('program/report/researcher/submitted'),
  programReportId: getByIdRequest('program/report/id'),
  programReportAttachmentFileList: getByIdRequest('program/report/attachment/file/list'),
  programReportAttachmentFileDownload: downloadRequest('program/report/attachment/file/download'),  

  programReportActivityByReport: reportActivityList(),
  reportActivityProfileImage: reportActivityProfileImage(),
  programReportActivityCommentCreate: reportCommentCreate(),
  programReportActivityCommentAttachment: reportCommentAttachment(),
  programReportActivityDisclosureRequest: setRequest('program/report/activity/request/disclosure'),
  programReportObjectionCreate: postByIdRequest('program/report/activity/objection/create'),
  programReportActivityAttachmentFileDownload: downloadRequest('program/report/activity/attachment/file/download'),

  // Organizations
  organizationQueryPage: queryPageRequest('organization'),
  rersearcherOrganizationFollowingQueryPage: queryPageRequest('researcher/organization/following'),
  researcherOrganizationFollow: putByIdRequest('researcher/organization/follow/set'),
  researcherOrganizationUnfollow: putByIdRequest('researcher/organization/follow/remove'),
  organizationProfileBase: getByIdRequest('organization/profile/general/base'),
  organizationProfileSub: getByIdRequest('organization/profile/general/sub'),
  organizationStatProgram: getByIdRequest('organization/stat/program'),
  organizationStatReport: getByIdRequest('organization/stat/program/report'),
  organizationStatReport: getByIdRequest('organization/stat/program/report'),
  programGeneralQueryPage: queryPageByIdRequest('program/general'),
  organizationAnnouncementQueryPage: queryPageByIdRequest('organization/announcement'),

  //Hacktions
  programHacktionQueryPage: queryPageRequest('program/report/hacktion'),
  
  programReportSummaryId: getByIdRequest('program/report/summary/id'),
  programReportAttachmentFileHacktivityList: getByIdRequest('program/report/attachment/file/hactivity/list'),
  programReportAttachmentFileHacktivityDownload: downloadRequest('program/report/attachment/file/hactivity/download'),

  programReportHacktionActivityByReport: getByIdRequest('program/report/activity/byreport'),
  programReportActivityAttachmentFileHacktivityDownload: downloadRequest('program/report/activity/attachment/file/hactivity/download'),

  // Payments
  paymentTransactionQueryPage: queryPageRequest('payment/transaction/byresearcher'),
  paymentTransactionSupportCreate: postByIdRequest('payment/transaction/support/create'),

  // Leaderboard
  // Leaderboard
  leaderboardQueryPage: queryPageRequest('researcher/leaderboard'),
  // leaderboardLastWeekList: getRequest('leaderboard/lastweek/list'),
  // leaderboardLastMonthList: getRequest('leaderboard/lastmonth/list'),

  // Support
  supportQueryPage: queryPageRequest('support'),
  newSupport: postRequest('support/save'),
  supportResponse: getByIdRequest('support/id'),

  //Profile
  researcherProfileInformation: getRequest('researcher/profile/base'),
  researcherProfileSub: getRequest('researcher/profile/sub'),
  researcherProfilePerformance: getRequest('reseacher/profile/performance'),
  researcherProfilePerformanceBadges: getRequest('researcher/profile/badges'),
  researcherProfileBadgesVisibility: putByIdRequest('researcher/profile/badges/set/visibility'),
  researcherProfileSkill: getRequest('researcher/skill/mylist'),
  researcherProfileInterest: getRequest('researcher/interest/mylist'),
  profileSecurityInformation: queryPageRequest('logging/login'),
  profileProgramRecentlyJoinedList: getRequest('researcher/program/recently/joined/list'),
  profileProgramRecentlyFollowingList: getRequest('researcher/program/recently/following/list'),
  ImageSave: postRequest('user/save/profile/image'),

  researcherSaveVerificationImage: postRequest('researcher/save/verification/image'),

  researcherProfilePaymentMethod: getRequest('researcher/payment/method/byresearcher'),
  researcherPaymentMethodDelete: deleteRequest('payment/method/delete/:id?'),
  researcherProfileAddPaymentMethod: postRequest('researcher/payment/method/save'),
  researcherProfileDeletePaymentMehod: deleteRequest('researcher/payment/method'),
  skillList: getRequest('skill/list'),
  researcherProfileAddSkill: postRequest('researcher/skill/save'),
  suggestionSave: postRequest('researcher/suggestion/save'),
  interestList: getRequest('interest/list'),
  researcherProfileAddInterest: postRequest('researcher/interest/save'),
  researcherProfileInfoEdit: postRequest('researcher/profile/personel/details/update'),
  researcherProfileSocialMediaEdit: postRequest('researcher/profile/socialmedia/update'),
  researcherProfileAboutEdit: postRequest('researcher/profile/about/update'),
  researcherProfilePaymentDefault: putByIdRequest('researcher/payment/method/make/default'),
  deletePaymentMethodSuccess: deleteRequest('researcher/payment/method'),
  researcherProfileProgramShow: getRequest('researcher/profile/program/show'),
  researcherProfileSetJoined: putByIdRequest('researcher/profile/set/joined'),
  researcherProfileSetFollowed: putByIdRequest('researcher/profile/set/followed'),

  changePass: postRequest('user/change/password'),

  researcherByIdProfileSub: getByIdRequest('researcher/profile/general/sub'),
  researcherByIdProfileInformation: getByIdRequest('researcher/profile/general/base'),
  researcherByIdProfileSkill: getByIdRequest('researcher/skill/general/byresearcher'),
  researcherByIdProfileInterest: getByIdRequest('researcher/interest/general/byresearcher'),
  researcherByIdProfilePerformance: getByIdRequest('researcher/profile/general/performance'),
  researcherByIdProfilePerformanceBadges: getByIdRequest('researcher/profile/general/badges'),
  researcherProfileGeneralProgramShow: getByIdRequest('researcher/profile/general/program/show'),
  researcherProgramRecentlyJoinedList: getByIdRequest('researcher/program/recently/joined/list'),
  researcherProgramRecentlyFollowingList: getByIdRequest('researcher/program/recently/following/list'),

  researcherStatProgramReport: getRequest('researcher/stat/program/report'),
  
  //Notification
  notificationTaskShort: queryPageRequest('notification/task/short'),
  notificationTask: queryPageRequest('notification/task'),
  notificationActivityShort: queryPageRequest('notification/activity/short'),
  notificationActivity: queryPageRequest('notification/activity'),
  notificationAnnouncementShort: queryPageRequest('notification/announcement/short'),
  notificationAnnouncement: queryPageRequest('notification/announcement'),
  notificationCollabrationShort: queryPageRequest('notification/collaborate/short'),
  notificationCollabration: queryPageRequest('notification/collaborate'),
  notificationPayment: queryPageRequest('notification/payment'),

  //Topbar Right Announcement
  notificationTaskNewCount: newCount('notification/task/newcount'),
  notificationActivityNewCount: newCount('notification/activity/newcount'),
  notificationAnnouncementNewCount: newCount('notification/announcement/newcount'),

  //Topbar Right Colloboration
  notificationColloborationNewCount: newCount('notification/collaborate/newcount'),
  notificationPaymentNewCount: newCount('notification/payment/newcount'),
  colloborationInvitation: getByIdRequest('notification/collaborate/id'),
  colloborationAccept: setRequest('program/report/collaborate/request/accept'),
  colloborationReject: putByIdRequest('program/report/collaborate/request/reject')
  //NotificationTab

});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
